export default "__VITE_ASSET__BjytgygT__"